import { useEffect } from "react";

import {
    useFastshiftAnalyticsData,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";
import { useFastshiftSelector } from "@/components/fastshift/src/state";

export const useMigrationTicketsListSectionAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
    const { fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

    const selectedDomainOrg = useFastshiftSelector(
        (state) => state.selectedDomainOrg
    );

    const { data: topSupportRequestsData } = useFastshiftSelector(
        (state) => state.topSupportRequests
    );

    // Track event for migration tickets list displayed
    useEffect(() => {
        if (!identityAttrs || !selectedDomainOrg || !topSupportRequestsData)
            return;

        fireTrackEvent({
            action: ActionKey.DISPLAYED,
            actionSubject: ActionSubjectKey.SECTION,
            actionSubjectId:
                ActionSubjectIdKey.MIGRATION_TICKETS_TOP_SECTION_DETAILS,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedDomainOrg.orgId,
                planTicketList: topSupportRequestsData.supportTickets.map(
                    ({ supportTicketId }) => supportTicketId
                )
            }
        });
    }, [
        fireTrackEvent,
        sourceKey,
        selectedDomainOrg,
        topSupportRequestsData,
        identityAttrs
    ]);
};
